import LocalStorageBackend from "i18next-localstorage-backend"

import CrowdinBackend from "./crowdin-backend"

export default [LocalStorageBackend, CrowdinBackend]
   